import ToolToggleBlock from './ToolToggleBlock';

class ToolToggleHeading2 extends ToolToggleBlock {
  static toolName = 'Heading 2';
  static iconClass = 'fa-regular fa-h2';
  static blockType = 'h2';
  static shortcut = 'Cmd+Option+2';
}

export default ToolToggleHeading2;
